import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from './services/auth.service';
import { de } from './utils/language.utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  public isLoading = true;

  $destroy = new Subject<void>();

  constructor(
    private config: PrimeNG,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.authCheck$
      .pipe(takeUntil(this.$destroy))
      .subscribe(isAuthenticated => {
        if (isAuthenticated === null) {
          return;
        }
        this.isLoading = false;
      });
    this.config.setTranslation(de);
  }

  ngOnDestroy() {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
